
import Vue from "vue";

export default Vue.extend({
  name: "StepperComponent",
  props: {
    currentStep: {
      type: Number,
    },
  },
  components: {},
  data: () => ({
    copied: false,
    hash: "sample-hash",
    signature: "sample-signature",
    signer: "sample-signer",
  }),
  methods: {},
});
